import SmallHeadingBlock from './smallHeadingBlock';

export default SmallHeadingBlock;
